/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiCreateWebhook,
    ApiCreateWebhookFromJSON,
    ApiCreateWebhookToJSON,
    ApiWebhook,
    ApiWebhookFromJSON,
    ApiWebhookToJSON,
    ApiWebhookPage,
    ApiWebhookPageFromJSON,
    ApiWebhookPageToJSON,
    ApiWebhookRequest,
    ApiWebhookRequestFromJSON,
    ApiWebhookRequestToJSON,
} from '../models';

export interface AddWebhookRequest {
    apiCreateWebhook: ApiCreateWebhook;
}

export interface DeleteWebhookRequest {
    webhookId: number;
}

export interface FindWebhooksRequest {
    page: number;
    size: number;
}

export interface TestWebhookRequest {
    webhookId: number;
}

export interface UpdateWebhookRequest {
    webhookId: number;
    apiCreateWebhook: ApiCreateWebhook;
}

/**
 * 
 */
export class WebhookApi extends runtime.BaseAPI {

    /**
     * Creates a new webhook
     */
    async addWebhookRaw(requestParameters: AddWebhookRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiWebhook>> {
        if (requestParameters.apiCreateWebhook === null || requestParameters.apiCreateWebhook === undefined) {
            throw new runtime.RequiredError('apiCreateWebhook','Required parameter requestParameters.apiCreateWebhook was null or undefined when calling addWebhook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/webhooks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiCreateWebhookToJSON(requestParameters.apiCreateWebhook),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiWebhookFromJSON(jsonValue));
    }

    /**
     * Creates a new webhook
     */
    async addWebhook(requestParameters: AddWebhookRequest, initOverrides?: RequestInit): Promise<ApiWebhook> {
        const response = await this.addWebhookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an existing webhook
     */
    async deleteWebhookRaw(requestParameters: DeleteWebhookRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiWebhook>> {
        if (requestParameters.webhookId === null || requestParameters.webhookId === undefined) {
            throw new runtime.RequiredError('webhookId','Required parameter requestParameters.webhookId was null or undefined when calling deleteWebhook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/webhooks/{webhookId}`.replace(`{${"webhookId"}}`, encodeURIComponent(String(requestParameters.webhookId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiWebhookFromJSON(jsonValue));
    }

    /**
     * Delete an existing webhook
     */
    async deleteWebhook(requestParameters: DeleteWebhookRequest, initOverrides?: RequestInit): Promise<ApiWebhook> {
        const response = await this.deleteWebhookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches webhooks
     */
    async findWebhooksRaw(requestParameters: FindWebhooksRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiWebhookPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findWebhooks.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findWebhooks.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/webhooks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiWebhookPageFromJSON(jsonValue));
    }

    /**
     * Fetches webhooks
     */
    async findWebhooks(requestParameters: FindWebhooksRequest, initOverrides?: RequestInit): Promise<ApiWebhookPage> {
        const response = await this.findWebhooksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test a webhook
     */
    async testWebhookRaw(requestParameters: TestWebhookRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiWebhookRequest>> {
        if (requestParameters.webhookId === null || requestParameters.webhookId === undefined) {
            throw new runtime.RequiredError('webhookId','Required parameter requestParameters.webhookId was null or undefined when calling testWebhook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/webhooks/{webhookId}/test`.replace(`{${"webhookId"}}`, encodeURIComponent(String(requestParameters.webhookId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiWebhookRequestFromJSON(jsonValue));
    }

    /**
     * Test a webhook
     */
    async testWebhook(requestParameters: TestWebhookRequest, initOverrides?: RequestInit): Promise<ApiWebhookRequest> {
        const response = await this.testWebhookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing webhook
     */
    async updateWebhookRaw(requestParameters: UpdateWebhookRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiWebhook>> {
        if (requestParameters.webhookId === null || requestParameters.webhookId === undefined) {
            throw new runtime.RequiredError('webhookId','Required parameter requestParameters.webhookId was null or undefined when calling updateWebhook.');
        }

        if (requestParameters.apiCreateWebhook === null || requestParameters.apiCreateWebhook === undefined) {
            throw new runtime.RequiredError('apiCreateWebhook','Required parameter requestParameters.apiCreateWebhook was null or undefined when calling updateWebhook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/webhooks/{webhookId}`.replace(`{${"webhookId"}}`, encodeURIComponent(String(requestParameters.webhookId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiCreateWebhookToJSON(requestParameters.apiCreateWebhook),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiWebhookFromJSON(jsonValue));
    }

    /**
     * Update an existing webhook
     */
    async updateWebhook(requestParameters: UpdateWebhookRequest, initOverrides?: RequestInit): Promise<ApiWebhook> {
        const response = await this.updateWebhookRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
